/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField } from '@jutro/legacy/components';
import { Icon, DateField } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './PastDesignandBuildingProjectsComponent.module.scss';
import metadata from './PastDesignandBuildingProjectsComponent.metadata.json5';

function PastDesignandBuildingProjectsComponent(props) {

    const {
        data: PastDesignandBuildingProjectsVM,
        updateWizardData,
        submissionVM,
        PastDesignandBuildingProjectsPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addPastDesignandBuildingProjects = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PastDesignandBuildingProjectsVM.value = PastDesignandBuildingProjectsVM.value || []

            const { _xCenter, _dtoName } = PastDesignandBuildingProjectsVM;

            const PastDesignandBuildingProjectsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            PastDesignandBuildingProjectsVM.pushElement(
                PastDesignandBuildingProjectsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PastDesignandBuildingProjectsVM, viewModelService]
    );

    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PastDesignandBuildingProjectsVM.value.splice(index, 1);
            _.set(submissionVM.value, PastDesignandBuildingProjectsPath, PastDesignandBuildingProjectsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PastDesignandBuildingProjectsPath, PastDesignandBuildingProjectsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'proNamAndCli1') {
                const value = item.proNamAndCli1 ? item.proNamAndCli1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.proNamAndCli1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'proAdd2') {
                const value = item.proAdd2 ? item.proAdd2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.proAdd2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'cit3') {
                const value = item.cit3 ? item.cit3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.cit3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'pro4') {
                const value = item.pro4 ? item.pro4 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.pro4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'posCod5') {
                const value = item.posCod5 ? item.posCod5 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        // dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.posCod5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'conVal6') {
                const value = item.conVal6 ?? '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.conVal6 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={9999999999}
                    />
                );
            }

            if (path === 'natOfSer7') {
                const value = item.natOfSer7 ? item.natOfSer7 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.natOfSer7 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'comDat8') {
                const value = item.comDat8 ? item.comDat8 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            item.comDat8 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }
        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        PastDesignandBuildingProjectsTable: {
            data: PastDesignandBuildingProjectsVM.value,
        }

    }), [PastDesignandBuildingProjectsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPastDesignandBuildingProjects,
            getTableCell,
            removeAssignmentTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PastDesignandBuildingProjectsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PastDesignandBuildingProjectsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PastDesignandBuildingProjectsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PastDesignandBuildingProjectsComponent.propTypes = wizardProps;
export default withRouter(PastDesignandBuildingProjectsComponent);
